import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { extraLandingRoute } from "../../utils/landingRoutes";

const ProtectedRoute = ({ children, allowedRoles, requiredPermission }) => {
  const { token, user, isReady } = useAuth();
  const location = useLocation();

  if (!isReady) {
    return null; // or a loading spinner
  }

  if (!token) {
    return <Navigate to="/authentication/sign-in" state={{ from: location }} replace />;
  }

  if (allowedRoles?.length && !allowedRoles.includes(user?.role || "admin")) {
    return <Navigate to={user?.role === "staff" ? "/purchase-requisition" : "/dashboard"} replace />;
  }

  if (
    requiredPermission
    && !["admin", "staff"].includes(user?.role)
    && !Array.isArray(user?.permissions)
  ) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  if (
    requiredPermission
    && !["admin", "staff"].includes(user?.role)
    && !user.permissions.includes(requiredPermission)
  ) {
    const firstAllowedRoute = user.permissions.includes("dashboard")
      ? "/dashboard"
      : user.permissions.includes("dms") && user.permissions.includes("add_seller")
        ? "/add-seller"
        : user.permissions.includes("dms") && user.permissions.includes("add_item")
          ? "/add-item"
          : user.permissions.includes("dms") && user.permissions.includes("item_list")
            ? "/dms-stock"
            : user.permissions.includes("update_payment")
              ? "/update-payment"
              : user.permissions.includes("bank_deposit")
                ? "/bank-deposit"
              : user.permissions.includes("out_bill")
                ? "/out-bill"
                : user.permissions.includes("requisition_approval")
                  ? "/requisition-approvals"
                : user.permissions.includes("location_assignments")
                    ? "/location-assignments"
                  : user.permissions.includes("packaging")
                    ? "/packaging"
                  : user.permissions.includes("delivery")
                    ? "/delivery"
                  : user.permissions.includes("delivered")
                    ? "/delivered"
                  : user.permissions.includes("add_outlet")
                  ? "/add-outlet"
                  : user.permissions.includes("add_sales")
                    ? "/add-sales"
                    : extraLandingRoute(user.permissions);
    return <Navigate to={firstAllowedRoute} replace />;
  }

  return children;
};

export default ProtectedRoute;
